import axios from 'helpers/axios';

const PAGE_SIZE = 20;

export const getPlayerFundFlows = async ({ queryKey }) => {
    const [, selectType, page, pageSize] = queryKey;
    const { data } = await axios.get('/api/adminapi/playerfundflow/', {
        params: {
            is_processed: selectType === 'processed',
            limit: pageSize,
            offset: page * pageSize,
        }
    });

    return data;
};

export const getPlayerFundFlowDetail = async ({ queryKey }) => {
    const [, id] = queryKey;
    const { data } = await axios.get(`/api/adminapi/playerfundflow/${id}/`);

    return data;
};

export const confirmPlayerFundFlow = async (id: string) => {
    const { data } = await axios.post(`/api/adminapi/playerfundflow/${id}/confirm/`);

    return data;
};
